import { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'

import { newsArticleSchema } from 'reactGarden/common/utils/contentSchema'
import ShapeThumb from 'reactGarden/common/prop-types/ThumbContent'

import ThumbInfo from './components/ThumbInfo'
import ThumbPicture from './components/ThumbPicture'

const ContentsThumb = ({ item }) => (
  <Fragment>
    <Helmet>
      <script type="application/ld+json">
        {`${JSON.stringify(newsArticleSchema(item))}`}
      </script>
    </Helmet>
    <div className="content-thumbnail">
      <ThumbPicture data={ item } />
      <ThumbInfo data={ item } />
    </div>
  </Fragment>
)

ContentsThumb.propTypes = {
  item: PropTypes.shape({ ...ShapeThumb }).isRequired
}

export default ContentsThumb
